import { InjectionToken, Provider } from '@angular/core';

import { MembersLibConfig } from '@lib/members/feature/models';

export const MEMBERS_LIB_CONFIG = new InjectionToken<MembersLibConfig>('MEMBERS_LIB_CONFIG');

export function provideMembersLibConfig(config: MembersLibConfig): Provider {
  return {
    provide: MEMBERS_LIB_CONFIG,
    useValue: config,
  };
}
